import { EventEmitter } from 'events';

export const emitter = new EventEmitter();

emitter.setMaxListeners(100);

export const subscribe = <T = unknown>(event: string, handler: (...args: T[]) => void) =>
    emitter.on(event, handler);

export const unsubscribe = <T = unknown>(event: string, handler: (...args: T[]) => void) =>
    emitter.off(event, handler);

export const publish = <T = unknown>(event: string, data: T) => emitter.emit(event, data);
